import styled from 'styled-components'
import PropTypes from 'prop-types'

const Spacer = styled.div`
  border-bottom: 2px solid black;
  width: 63px;

  ${({ padded }) => padded && `
    margin: 64px 0;
  `}
`

Spacer.defaultProps = {
}

Spacer.propTypes = {
  padded: PropTypes.bool,
}

export default Spacer
